import React from "react";
import FormSubmitted from "../../shared/components/FormSubmitted";

/**
 * The enquiry form's thank-you: the shared screen, and the one sentence on it
 * that is this form's own.
 *
 * The brand is named where there is one — "Priya Nutrition will get back to
 * you" — because a stranger who filled in a form from a link in a bio may not
 * be sure whose form it was by the time they reach the end of it.
 */

interface PublicEnquirySubmittedProps {
  brandName: string;
}

const PublicEnquirySubmitted: React.FC<PublicEnquirySubmittedProps> = ({
  brandName,
}) => (
  <FormSubmitted
    message={
      <>
        Thanks for sharing your details, will get back to you shortly.
      </>
    }
  />
);

export default PublicEnquirySubmitted;
